import React from 'react';
import Timeline from '../../components/Timeline/Timeline';
import FontAwesome from 'react-fontawesome';
import SafecoExplainer from '../SafecoExplainer/SafecoExplainer';

const WhoWeAre = () => {
    return (
        <Timeline
            heading="who we are"
            icon={
                <FontAwesome
                    className="primary-yellow con md image_center icon175"
                    name="question"
                    datacy="question"
                    size="2x"
                />
            }>
            <SafecoExplainer />
        </Timeline>
    );
};

export default WhoWeAre;



// WEBPACK FOOTER //
// ./src/containers/WhoWeAre/WhoWeAre.jsx